import WALLETS_API from 'api/wallets/v1'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { notificationShow } from 'modules/Notifications/actions'
import { cancellableCall } from 'store/saga-utils/cancellableCall.saga'
import {
  FETCH_WALLET_TRANSACTIONS,
  FETCH_WALLETS,
  SET_WALLET_NAME,
  SET_WALLET_TRANSACTIONS,
  SET_WALLETS,
} from 'modules/Finance/Wallets/store/types'
import extractErrors from 'utils/extractErrors'

export function* fetchWallets() {
  try {
    yield put({ type: SET_WALLETS, payload: { loading: true } })

    const { response, error } = yield call(WALLETS_API.fetchWallets)

    if (error) {
      throw error
    }

    yield put({
      type: SET_WALLETS,
      payload: { ...response, loaded: true },
    })
  } catch (error) {
    yield put({
      type: SET_WALLETS,
      payload: { failed: true },
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({ type: SET_WALLETS, payload: { loading: false, loaded: true } })
  }
}

export function* getWalletTransactions({ payload }) {
  const {
    transactions: { data: transactions = [] },
  } = yield select((state) => state['finance/wallets'])

  try {
    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: {
        loading: true,
      },
    })

    const { id, ...rest } = payload

    const { canceled, response, error } = yield cancellableCall(
      WALLETS_API.fetchTransactions,
      { id, params: { ...rest } },
      arguments,
    )

    if (error) {
      throw error
    }

    if (canceled) return

    const { data = [], pagination, summary = {} } = response

    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: {
        data: [...transactions, ...data],
        pagination,
        categories: summary,
        loaded: true,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: SET_WALLET_TRANSACTIONS,
      payload: { failed: true, loading: false, loaded: false, data: [] },
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  }
}

export function* setWalletName({ payload }) {
  const { walletID, meta: { resolve, reject } = {}, name } = payload

  try {
    const {
      wallets: { data: wallets = [] },
    } = yield select((state) => state['finance/wallets'])

    const { error } = yield call(WALLETS_API.setWalletName, {
      walletID,
      data: { name },
    })

    if (error) {
      throw error
    }

    yield put({
      type: SET_WALLETS,
      payload: {
        data: wallets.map((wallet) => (wallet.id === +walletID ? { ...wallet, name } : wallet)),
      },
    })
    resolve()
  } catch (error) {
    const { fields } = extractErrors(error.errors)

    yield put(
      notificationShow({
        type: 'error',
        message: fields?.name ?? 'common::notifications.data_fetch_failed',
      }),
    )

    console.logXHR(error)
    reject && reject()
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_WALLETS, fetchWallets)

  yield takeLatest(FETCH_WALLET_TRANSACTIONS, getWalletTransactions)

  yield takeLatest(SET_WALLET_NAME, setWalletName)
}
